// @flow

const feedDialogStyles = {
  dialogPaperWidthSm: (theme) => ({
    maxWidth: '90vw',
    width: '90vw',
    padding: '10px 16px 16px 16px',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 8px 8px 8px'
    }
  }),
  marginTop: (theme) => ({
    marginTop: theme.spacing(1)
  })
};

export default feedDialogStyles;